const themeContract = {
  tu: {
    benefitsIconColor: {
      color: 'grey-90'
    },
    serviceButton: {
      color: 'darker',
      background: '',
      border: 'darker'
    },
    background: {
      color: 'lighter'
    }
  },
  argos: {
    benefitsIconColor: {
      color: 'green'
    },
    serviceButton: {
      color: 'darker',
      background: 'lighter',
      border: 'darker'
    },
    background: {
      color: 'lighter'
    }
  },
  habitat: {
    benefitsIconColor: {
      color: 'grey-90'
    },
    serviceButton: {
      color: 'darker',
      background: 'lighter',
      border: 'darker'
    },
    background: {
      color: 'lighter'
    }
  },
  nectar: {
    benefitsIconColor: {
      color: 'purple'
    },
    serviceButton: {
      color: 'darker',
      background: 'white',
      border: 'darker'
    },
    background: {
      color: 'white'
    }
  },
  sainsburys: {
    benefitsIconColor: {
      color: 'grey-80'
    },
    serviceButton: {
      color: '',
      background: '',
      border: ''
    },
    background: {
      color: 'white'
    }
  }
}

export { themeContract }
